import React, { FC } from 'react';
import NCFileGeneralContent from './NCFileGeneralContent';
import { scale } from '@components/frame';
import { NCFileSearchItem } from '@interfaces/search';
import {
  DETAILS_SCREENS_CONTAINER_STYLES,
  IMAGES_PANEL_VIEW_MODE_WIDTH,
  PANEL_VIEW_MODE_WIDTH,
} from '../../../../../../common/constants/base.constants';
import { isPhone, isWeb } from '@helpers';
import ImagesContainer, { ImagesContainerMode } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import { View } from 'react-native';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { NCFileDetailsScreenName } from '@v2/pages/nc-file/details/navigation/config';
import { NCFileDetailsScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import { LevelSubScreen, Perspective } from '@v2/pages/common/enums';
import { useRoute } from '@react-navigation/native';

interface NCFileListOrSingleItemProps {
  ncFileData: (NCFileSearchItem | null)[];
  ncFileId: number | null | undefined;
  ncFileDataLoading?: boolean;
  ncFileDataLoadingForList?: boolean;
}

const NCFileListOrSingleItem: FC<NCFileListOrSingleItemProps> = ({ ncFileData, ncFileId, ncFileDataLoading, ncFileDataLoadingForList }) => {
  const shouldDisplaySingleNCFile = ncFileData.filter(Boolean)?.length === 1;
  const route = useRoute();

  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const onNCFileImageClick = (selectedImageKey: string) => {
    // Extract NC file details from data
    const ncFile = ncFileData?.find((item) => item !== null);
    const ncFileName = ncFile?.ncFileName;
    const ncFileStatus = ncFile?.ncFileStatus || route.params?.ncFileStatus;

    navigateToMainDetailsScreen({
      mainScreen: NCFileDetailsScreenName,
      subScreen: NCFileDetailsScreen.NC_FILE,
      levelSubScreen: LevelSubScreen.DOCUMENTS,
      params: {
        perspective: Perspective.NC_FILE,
        ncFileId: ncFileId,
        ncFileName: ncFileName,
        ncFileStatus: ncFileStatus,
        selectedImageKey,
      },
    });
  };

  return (
    <View
      style={{
        flexDirection: 'row',
        maxWidth: scale(PANEL_VIEW_MODE_WIDTH),
        marginInline: 'auto',
        width: '100%',
        ...DETAILS_SCREENS_CONTAINER_STYLES,
        paddingHorizontal: 0,
      }}
    >
      <NCFileGeneralContent
        ncFileDataLoading={!!ncFileDataLoading}
        ncFileData={ncFileData}
        maxDetailsWidth={scale(PANEL_VIEW_MODE_WIDTH - IMAGES_PANEL_VIEW_MODE_WIDTH)}
        noMachine
        withImages={isPhone && shouldDisplaySingleNCFile}
        currentNcFileId={ncFileId}
        ncFileDataLoadingForList={ncFileDataLoadingForList}
        bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
      />
      {ncFileDataLoading && !isPhone && shouldDisplaySingleNCFile && (
        <View style={{ width: IMAGES_PANEL_VIEW_MODE_WIDTH, paddingLeft: scale(18), height: '100%' }} />
      )}
      {!ncFileDataLoading && !isPhone && shouldDisplaySingleNCFile && (
        <ImagesContainer
          panelViewMode
          mode={ImagesContainerMode.COLUMN}
          documentRetrieveId={ncFileId}
          documentRetrieveKey={DOCUMENT_ENTITY_TYPE.NcFile}
          onImagePress={onNCFileImageClick}
        />
      )}
    </View>
  );
};

export default NCFileListOrSingleItem;
